import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($options.hasContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "header"),
        ($props.isRichText)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(['gfu-richtext', {'gfu-richtext--article' :$props.isArticle }]),
              innerHTML: $props.content
            }, null, 10 /* CLASS, PROPS */, _hoisted_2))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString($props.content), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}